import { Component } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { DatePipe, Location } from '@angular/common';
import { IataCommissionService } from 'src/app/services/iata-commission.service';
import { ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import {AirManagementService}  from 'src/app/services/air-management.service'

@Component({
  selector: 'app-iata-commission',
  templateUrl: './iata-commission.component.html',
  styleUrls: ['./iata-commission.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class IataCommissionComponent {
  columnsDisplay: string[] = ['iataCode','carrierName','sTax','ClubYQ','ClubOC','ClubCongestion','Commission'];
  expandedElement!: any | null;
  iataCommissionData:any=[]
  fileSelected:boolean=false
  selectedFile:any=null
  constructor(private toastMsgService : ToastmsgService,private iataCommissionService :IataCommissionService,private AirManagementService:AirManagementService){
    this.carrierCodelist()
  }
  onFileSelected(event: any): void {
    
      this.fileSelected=true;

   
    this.selectedFile = event.target.files[0] ?? null;
   
  }

  formatDate(val: Date) {
    let convertedValue:any = ""
    if(val){
    let datepipe = new DatePipe("en");
    //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
    convertedValue =  datepipe.transform(val, "dd-MM-yyyy hh:mm:ssa");
    }
    return convertedValue;
  }
  onlyNumberKey(event:any) {
     
    let charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31
        && (charCode < 48 || charCode > 57))
        return false;
    return true;
  }

  uploadFile(){
    this.fileSelected=true;

    this.iataCommissionService
    .UploadIataCommissions(this.selectedFile)
    .subscribe({
      next : (res:any) => {
        if(res) {
        this.fileSelected=false
        this.selectedFile=null

          this.toastMsgService.setMsg({msg : "Upload File Successfully!",msgTitle : "Success", msgType : "I"});

        } else {
        
        } 
      },error : (err) => {
        this.toastMsgService.setMsg({msg : "Failed to Upload File",msgTitle : "Warning", msgType : "W"});


      }
    }
  )
  }
  carrierCodeList:any=[]
  carrierCodelist(){

    this.AirManagementService
    .carrierlist()
    .subscribe({
      next : (res:any) => {
        if(res) {
       let data=res
       this.carrierCodeList=data
       
        } else {
        
        } 
      },error : (err) => {
  
      }
    }
  )
  }
  carrierCode:any
  commissionList(){

    this.AirManagementService
    .iataCommissionlist(this.carrierCode)
    .subscribe({
      next : (res:any) => {
        if(res) {
       let data=res
       this.iataCommissionData=[data]
        } else {
        
        } 
      },error : (err) => {
  
      }
    }
  )
  }





  updateCommission(item:any){

    this.iataCommissionService
    .UpdateIataCommissions(item)
    .subscribe({
      next : (res:any) => {
        if(res.status==200 || res.status==201) {
       this.commissionList()

          this.toastMsgService.setMsg({msg : "Update Iata Commission Successfully!",msgTitle : "Success", msgType : "I"});

        } else {
        
        } 
      },error : (err) => {
        this.toastMsgService.setMsg({msg : "Failed to Update",msgTitle : "Warning", msgType : "W"});


      }
    }
  )
  }
}
